import { render, staticRenderFns } from "./AboutCard.vue?vue&type=template&id=72a68e9c&scoped=true&"
import script from "./AboutCard.vue?vue&type=script&lang=js&"
export * from "./AboutCard.vue?vue&type=script&lang=js&"
import style0 from "./AboutCard.vue?vue&type=style&index=0&id=72a68e9c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72a68e9c",
  null
  
)

export default component.exports